/** Vite env 레코드를 `TelemetryEnv`로 정규화한다. */
export function parseTelemetryEnv(env) {
    return {
        enabled: env.VITE_ENABLE_TELEMETRY === 'true',
        connectionString: env.VITE_APPINSIGHTS_CONNECTION_STRING,
        clarityProjectId: env.VITE_CLARITY_PROJECT_ID,
    };
}
//# sourceMappingURL=types.js.map